import React from "react";
import Card from "react-bootstrap/Card";

const FeatureCard = ({ feature }) => {
  const { title, des, img } = feature;

  return (
    <>
      <div className="col-lg-4">
        <div className="feature-card mt-3">
          <Card>
            <Card.Img
              style={{ height: "280px", marginTop: "20px" }}
              className="feature-img"
              variant="top"
              src={img}
            />
            <Card.Body>
              <Card.Title>{title}</Card.Title>
              <Card.Text>{des.slice(0, 300)}...</Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default FeatureCard;
